import { ALGOS_E } from "@constants/Algos";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { HashFactorName } from "@utils/hash.utils";
import { MTFilters } from "./reducer";

export enum ActionTypesFilters {
  SET_MINER_TABLE_FILTERS = "SET_MINER_TABLE_FILTERS",
  SET_MINER_TABLE_SEARCH = "SET_MINER_TABLE_SEARCH",
  CLEAR_MINER_TABLE_FILTERS = "CLEAR_MINER_TABLE_FILTERS",
  SET_ADMIN_MINE_FILTER = "SET_ADMIN_MINE_FILTER",
  SET_LOCATION_FILTER = "SET_MINER_LOCATION",
  SET_OWNER_FILTER = "SET_OWNER_FILTER",
  SET_POOL_FILTER = "SET_POOL_FILTER",
  SET_PERCENT_FILTER = "SET_PERCENT_FILTER",
  SET_SPEED_LESS_FILTER = "SET_SPEED_LESS_FILTER",
  SET_SPEED_MORE_FILTER = "SET_SPEED_MORE_FILTER",
  SET_SPEED_LESS_PERCENT_FILTER = "SET_SPEED_LESS_PERCENT_FILTER",
  SET_MINER_TYPE_FILTER = "SET_MINER_TYPE_FILTER",
  SET_PLAN_FILTER = "SET_PLAN_FILTER",
  SET_MINER_STATE_FILTER = "SET_MINER_STATE_FILTER",
  SET_ALGO_FILTER = "SET_ALGO_FILTER",
  SET_DEFAULT_SPEED_LESS_FILTER = "SET_DEFAULT_SPEED_LESS_FILTER",
  SET_DEFAULT_SPEED_MORE_FILTER = "SET_DEFAULT_SPEED_MORE_FILTER",
  SET_INSTALAION_DATE_FILTER_LESS = "SET_INSTALAION_DATE_FILTER_LESS",
  SET_INSTALAION_DATE_FILTER_MORE = "SET_INSTALAION_DATE_FILTER_MORE",
  SET_BAGES_FILTER = "SET_BAGES_FILTER",
  SET_TAG_FILTER = "SET_TAG_FILTER",
  SET_BUILDING_FILTER = "SET_BUILDING_FILTER",
  SET_CONTRACT_FILTER = "SET_CONTRACT_FILTER",
  SET_CONTRACT_PLAN_FILTER = "SET_CONTRACT_PLAN_FILTER", // казалось бы уже есть SET_PLAN_FILTER...
  SET_MINER_HAS_ERRORS = "SET_MINER_HAS_ERRORS",
  SET_WITHOUT_FLAG = "SET_WITHOUT_FLAG",
  SET_WITHOUT_PLAN = "SET_WITHOUT_PLAN",
  SET_WITHOUT_CONTRACTS = "SET_WITHOUT_CONTRACTS",
  SET_FLAGS = "SET_FLAGS",
  SET_WITH_DUP_IP = "SET_WITH_DUP_IP",
  SET_WITH_DUP_MAC = "SET_WITH_DUP_MAC",
  //SET_WITH_LOCATION = "SET_WITH_LOCATION",
}

export interface ActionBaseFilters {
  type: ActionTypesFilters;
  payload?: any;
}

export interface ActionSetMTFilters extends ActionBaseFilters {
  payload: MTFilters;
}

export interface ActionMTSaveSearch extends ActionBaseFilters {
  payload: string[];
}

export interface ActionSetCurrentFilters extends ActionBaseFilters {
  //типы из MTFiltersValuesI
  payload:
  | boolean
  | string
  | string[]
  | MINER_STATUSES_E[]
  | ALGOS_E
  | number
  | undefined;
}

export interface IHashHamesPayload {
  less?: HashFactorName;
  more?: HashFactorName;
}

export interface ActionSetSpeedBage extends ActionBaseFilters {
  payload: IHashHamesPayload;
}
